/**
 * 시드 공용 도구 — 날짜 창, 근무일, 정해진 난수.
 *
 * 시드는 고정 날짜다. 2026-09-01 부터 SEED_TODAY 까지 일어난 일이 쌓여 있고, SEED_TODAY 는
 * 아직 제출하지 않은 날이다. 같은 시드는 언제 열어도 같은 데이터가 나온다(난수도 고정).
 */
import { isWeekend, shiftDate } from "@/lib/dates";
import { holidayDates } from "./holidays";

export const SEED_START = "2026-09-01";
/** 시드가 "오늘"로 삼는 날 — 할 일은 있고 제출은 아직 없다. */
export const SEED_TODAY = "2026-10-22";

export const isWorkday = (date: string) => !isWeekend(date) && !holidayDates.has(date);

/** from 부터 to 까지(둘 다 포함)의 근무일. */
export function workdays(from: string, to: string): string[] {
  const days: string[] = [];
  for (let d = from; d <= to; d = shiftDate(d, 1)) if (isWorkday(d)) days.push(d);
  return days;
}

/** 날짜 앞뒤로 가장 가까운 근무일 — step 이 -1 이면 앞쪽. */
export function nearestWorkday(date: string, step: 1 | -1): string {
  let d = shiftDate(date, step);
  while (!isWorkday(d)) d = shiftDate(d, step);
  return d;
}

/** 한국 시각 ISO 문자열. */
export const at = (date: string, time = "09:00") => `${date}T${time}:00+09:00`;

/** 문자열로 씨앗을 정하는 고정 난수(mulberry32) — 같은 씨앗이면 같은 수열. */
export function rng(seed: string) {
  let h = 1779033703 ^ seed.length;
  for (let i = 0; i < seed.length; i++) {
    h = Math.imul(h ^ seed.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  let a = h >>> 0;
  const next = () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    /** 0 이상 n 미만 정수 */
    int: (n: number) => Math.floor(next() * n),
    pick: <T>(list: readonly T[]): T => list[Math.floor(next() * list.length)],
    chance: (p: number) => next() < p,
  };
}
